import when from "ramda/es/when";
import isNotNil from "ramda-extension/es/isNotNil";
/**
 * Wrapper around `when` fn from `ramda`, except the input function will only get called with not nil params
 *
 * @documented
 * @category Function
 *
 * @param {Function} fn
 * @returns {Function} wrapped input fn
 * @example
 *
 * 		whenIsNotNil(console.log)('dog') // => dog
 *
 */ const whenIsNotNil = (fn)=>when(isNotNil, fn);
export default whenIsNotNil;
